<template>
  <div class="grid grid-cols-3 space-x-2 mb-1">
    <div class="col-span-1 flex flex-row space-x-2 items-center">
      <input class="h-full w-3/4"
        placeholder="key"
        v-model="formValues.key.input"
        @change="() => {
          valueDelete(oldKey)
          markPendingItem(formValues, 'key')
          valueChange()
        }"
      />
      <ExistingKeys
        @addKey="onAddExistingKey"
      />
      <span
        v-if="pendingKey">
        *
      </span>
    </div>
    <div class="col-span-2 flex flex-row space-x-2 items-center">
      <input class="h-full w-3/4"
        placeholder="value"
        v-model="formValues.value.input"
        @change="() => {
          markPendingItem(formValues, 'value')
          valueChange()
        }"
      />
      <span
        v-if="pendingValue">
        *
      </span>
      <div class="grow"></div>
      <XButton class="bg-orange-200 p-1 w-4 h-4 justify-center"
        @click="() => {
          deleteKeyValue()
          valueDelete(formValues.key.input)
        }"
      />
    </div>
  </div>
</template>

<script>
import XButton from '../../XButton.vue'

import ExistingKeys from './ExistingKeys.vue'

export default {
  props: {
    defaultValue: Object,
    value: undefined,
  },
  components: {
    XButton,
    ExistingKeys,
  },
  data() {
    return {
      formValues: {
        key: {
          current: undefined,
          input: undefined,
        },
        value: {
          current: undefined,
          input: undefined,
        },
      },

      oldKey: undefined,

      pendingKey: false,
      pendingValue: false,
    }
  },
  methods: {
    deleteKeyValue() {
      this.$emit('deleteKeyValue')
    },
    updateValue() {
      this.$emit('input', this.formValues)
    },
    markPendingItem(item, type) {
      if (type === 'key') {
        this.pendingKey = true
      }
      else if (type === 'value') {
        this.pendingValue = true
      }
      this.$emit('markPending', item, type)
    },
    onAddExistingKey(existingKey) {
      this.formValues.key.input = existingKey
      this.$emit('markPending', this.formValues, 'key')
    },
    valueChange(key) {
      let updateKey
      if (key) {
        updateKey = key
      }
      else {
        updateKey = this.formValues.key.input
      }

      try {
        this.$emit('keyValueChange', updateKey, JSON.parse(this.formValues.value.input))
      }
      catch {
        this.$emit('keyValueChange', updateKey, this.formValues.value.input)
      }

      this.oldKey = updateKey
    },
    valueDelete(key) {
      this.$emit('keyValueDelete', key)
    },
  },
  mounted() {
    this.formValues = this.defaultValue
  },
  watch: {
    value(newValue) {
      this.formValues = newValue
    },
    formValues() {
      this.updateValue()
    },
    defaultValue(newValue) {
      this.formValues = newValue
    },
  }
}
</script>
